import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { Logo } from "./Logo";

const SITE_PASSWORD = "Property";
const STORAGE_KEY = "growth_site_unlocked";
// Routes with their own gate (Strategy Intelligence uses the founders' passcode).
const BYPASS_PREFIXES = ["/roadmap"];

export default function SiteGate({ children }) {
  const [unlocked, setUnlocked] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const bypass = BYPASS_PREFIXES.some((p) => window.location.pathname === p || window.location.pathname.startsWith(p + "/"));
  if (unlocked || bypass) return children;

  const submit = (e) => {
    e.preventDefault();
    if (value.trim() === SITE_PASSWORD) {
      try { localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
      setUnlocked(true);
    } else {
      setError(true);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 relative overflow-hidden" style={{ background: "linear-gradient(135deg,#0B1A07 0%,#1C3A12 55%,#0B1A07 100%)" }}>
      <div className="blob" style={{ width: 620, height: 620, top: -220, right: -120, background: "radial-gradient(circle, rgba(147,192,32,.28), transparent 70%)" }} />
      <motion.div
        initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-sm"
      >
        <div className="flex justify-center mb-8"><Logo height={30} bare /></div>
        <div className="rounded-2xl p-8" style={{ background: "rgba(255,255,255,.06)", border: "1px solid rgba(255,255,255,.12)", backdropFilter: "blur(12px)" }}>
          <span className="grid place-items-center w-11 h-11 rounded-xl mb-5" style={{ background: "var(--grad-green)" }}><Lock size={20} color="#16180F" strokeWidth={2} /></span>
          <h1 className="text-2xl font-extrabold tracking-tighter text-white">Private preview</h1>
          <p className="text-sm text-white/60 mt-2 leading-relaxed">Enter the password to continue.</p>
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input
              type="password" autoFocus value={value}
              onChange={(e) => { setValue(e.target.value); setError(false); }}
              data-testid="site-gate-input" placeholder="Password"
              className="w-full rounded-xl px-4 py-3 text-sm text-white bg-white/10 border focus-ring placeholder:text-white/40"
              style={{ borderColor: error ? "rgba(229,120,120,.6)" : "rgba(255,255,255,.16)" }}
            />
            {error && <p className="text-sm font-medium" style={{ color: "#F0A6A6" }} data-testid="site-gate-error">Incorrect password. Try again.</p>}
            <button type="submit" data-testid="site-gate-submit" className="btn-primary w-full focus-ring !py-3">Enter <ArrowRight size={16} strokeWidth={2} /></button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
